import { shapeAsset } from "@/lib/shapes";

export const DELIVERY_APPROACH_HEADING =
  "Prototype early. Build deliberately. Scale responsibly.";

export const DELIVERY_APPROACH_STEPS = [
  {
    number: "01",
    title: "Understand the system",
    description:
      "We start by mapping constraints, dependencies, risk, and ownership before writing code.",
    shape: shapeAsset("cube", "coral"),
  },
  {
    number: "02",
    title: "Prototype to reduce risk",
    description:
      "We prototype selectively to validate workflows, integrations, and design direction early.",
    shape: shapeAsset("pyramid", "pink"),
  },
  {
    number: "03",
    title: "Build the first real version",
    description:
      "Systems are designed with growth, security, and integration in mind from day one.",
    shape: shapeAsset("ball", "blue"),
  },
  {
    number: "04",
    title: "Support and evolve",
    description:
      "We maintain and extend systems as requirements change, without forcing rewrites.",
    // Arch reads too thin at 24px; upright block reads like a column at icon size.
    shape: shapeAsset("rectangle-upright", "yellow"),
  },
] as const;
